import React, {Component, Fragment} from "react";
import authAction from "../../customApp/redux/auth/actions";
import {connect} from "react-redux";
const {logout} = authAction;
class AutoLogout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lastActivity: Date.now(),
        };
    }

    componentDidMount() {
        window.addEventListener('mousemove', this.handleActivity);
        window.addEventListener('keypress', this.handleActivity);
        window.addEventListener('click', this.handleActivity);
        this.activityCheckInterval = setInterval(this.checkActivity, 10000);
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.handleActivity);
        window.removeEventListener('keypress', this.handleActivity);
        window.removeEventListener('click', this.handleActivity);
        clearInterval(this.activityCheckInterval);
    }

    handleActivity = () => {
        this.setState({ lastActivity: Date.now() });
    };

    checkActivity = () => {
        const now = Date.now();
        const inactiveLimit = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
        const { lastActivity } = this.state;

        if (now - lastActivity > inactiveLimit) {
            this.logoutUser();
        }
    };

    logoutUser = () => {
        if (typeof this.props.logout === 'function') {
            this.props.logout();
        }
    };

    render() {
        return (
            <Fragment/>
        );
    }
}

export default connect(null, {logout})(AutoLogout);
